import Vue from "vue";
import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

import {
  GET_ATTORNEY_LIST,
  FETCH_ATTORNEY_DETAILS,
  CREATE_ATTORNEY,
  DELETE_ATTORNEY,
  APPROVE_ATTORNEY,
  REVOKE_ATTORNEY_APPROVAL,
  GENERATE_ATTORNEY_UPLOAD_TOKEN,
  GET_ATTORNEY_UPLOAD_STATUS,
  UPLOAD_ATTORNEY_DOCUMENT_MOBILE,
  UPLOAD_ATTORNEY_DOCUMENT_DIRECT,
  GET_ATTORNEY_DOCUMENTS,
  VERIFY_ATTORNEY_EMAIL
} from "../actions.type";

// A network failure/timeout has no err.response, so this always yields a
// usable error object instead of crashing (and silently hanging the caller)
// when trying to read response.data off undefined.
function extractError(err) {
  if (err && err.response && err.response.data) return err.response.data;
  return { msg: "Network error. Please check your connection and try again." };
}

const actions = {
  [GET_ATTORNEY_LIST]() {
    if (JwtService.getToken()) {
      return new Promise((resolve, reject) => {
        ApiService.get("get/attorney/list")
          .then(({ data }) => {
            resolve(data);
          })
          .catch(err => {
            reject(extractError(err));
          });
      });
    }
  },
  [FETCH_ATTORNEY_DETAILS](context, id) {
    if (JwtService.getToken()) {
      return new Promise((resolve, reject) => {
        ApiService.get("get/attorney/" + id)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(err => {
            reject(extractError(err));
          });
      });
    }
  },
  [CREATE_ATTORNEY](context, data) {
    if (JwtService.getToken()) {
      return new Promise((resolve, reject) => {
        ApiService.post("create/attorney/", data)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(err => {
            reject(extractError(err));
          });
      });
    }
  },
  [DELETE_ATTORNEY](context, id) {
    if (JwtService.getToken()) {
      return new Promise((resolve, reject) => {
        ApiService.get("delete/attorney/" + id)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(err => {
            reject(extractError(err));
          });
      });
    }
  },
  [APPROVE_ATTORNEY](context, id) {
    if (JwtService.getToken()) {
      return new Promise((resolve, reject) => {
        ApiService.get("approve/attorney/" + id)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(err => {
            reject(extractError(err));
          });
      });
    }
  },
  [REVOKE_ATTORNEY_APPROVAL](context, id) {
    if (JwtService.getToken()) {
      return new Promise((resolve, reject) => {
        ApiService.get("revoke/attorney-approval/" + id)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(err => {
            reject(extractError(err));
          });
      });
    }
  },
  [GENERATE_ATTORNEY_UPLOAD_TOKEN](context, attorneyId) {
    if (JwtService.getToken()) {
      return new Promise((resolve, reject) => {
        ApiService.post("generate/attorney-upload-token/", {
          attorney_id: attorneyId
        })
          .then(({ data }) => {
            resolve(data);
          })
          .catch(err => {
            reject(extractError(err));
          });
      });
    }
  },
  [GET_ATTORNEY_UPLOAD_STATUS](context, token) {
    if (JwtService.getToken()) {
      return new Promise((resolve, reject) => {
        ApiService.get("get/attorney-upload-status/" + token)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(err => {
            reject(extractError(err));
          });
      });
    }
  },
  [UPLOAD_ATTORNEY_DOCUMENT_MOBILE](context, { token, file }) {
    const formData = new FormData();
    formData.append("file", file);
    return new Promise((resolve, reject) => {
      Vue.axios
        .post("upload/attorney-document/" + token + "/", formData, {
          headers: { "Content-Type": "multipart/form-data" },
          timeout: 60000
        })
        .then(({ data }) => {
          resolve(data);
        })
        .catch(err => {
          reject(extractError(err));
        });
    });
  },
  [UPLOAD_ATTORNEY_DOCUMENT_DIRECT](context, { id, file }) {
    if (JwtService.getToken()) {
      const formData = new FormData();
      formData.append("file", file);
      return new Promise((resolve, reject) => {
        Vue.axios
          .post("upload/attorney-document-direct/" + id + "/", formData, {
            headers: { "Content-Type": "multipart/form-data" },
            timeout: 60000
          })
          .then(({ data }) => {
            resolve(data);
          })
          .catch(err => {
            reject(extractError(err));
          });
      });
    }
  },
  [GET_ATTORNEY_DOCUMENTS](context, id) {
    if (JwtService.getToken()) {
      return new Promise((resolve, reject) => {
        ApiService.get("get/attorney/" + id + "/documents")
          .then(({ data }) => {
            resolve(data);
          })
          .catch(err => {
            reject(extractError(err));
          });
      });
    }
  },
  [VERIFY_ATTORNEY_EMAIL](context, email) {
    return new Promise((resolve, reject) => {
      ApiService.post("verify/attorney-email/", { email })
        .then(({ data }) => {
          resolve(data);
        })
        .catch(err => {
          reject(extractError(err));
        });
    });
  }
};

export default {
  actions
};
